import React from 'react'
import { useTranslation } from 'react-i18next';
import Table from '../Table';
import chromeIcon from '../../assets/images/chrome.svg';
import firefoxIcon from '../../assets/images/firefox.svg';
import safariIcon from '../../assets/images/safari.svg';
import edgeIcon from '../../assets/images/edge.svg';
import explorerIcon from '../../assets/images/explorer.svg';
import vivalryIcon from '../../assets/images/vivaldy.svg';
import BraveIcon from '../../assets/images/brave.svg';
import operaIcon from '../../assets/images/opera.svg';
import torIcon from '../../assets/images/tor.svg';
import './compability-content.scss';
import tickIcon from '../../assets/images/tick.svg';

const CompatibilityContent = () => {
	const { t } = useTranslation();

	const columns = [
		{
			heading: `${t('browser')}`,
			accessor: 'browser',
			Cell: ({ row }) => <div className='browser-icons'>
				<img src={row.icon} alt={row.browser} />
				<p>{row.browser}</p>
			</div>
		},
		{
			heading: `${t('min_version')}`,
			accessor: 'version'
		},
		{
			heading: `${t('status')}`,
			accessor: 'status',
			Cell: ({ }) => <div>
				<img src={tickIcon} alt='status' />
			</div>
		}
	]

	const data = [
		{
			browser: 'Chrome',
			icon: chromeIcon,
			version: '79.0.3945.79',
			status: 'active'
		},
		{
			browser: 'Firefox',
			icon: firefoxIcon,
			version: '100.0.1',
			status: 'active'
		},
		{
			browser: 'Microsoft Edge',
			icon: edgeIcon,
			version: '90.0.881.51',
			status: 'active'
		},
		{
			browser: 'Safari',
			icon: safariIcon,
			version: '17.0.0',
			status: 'active'
		},
		{
			browser: 'Opera',
			icon: operaIcon,
			version: '100.0.4815.47',
			status: 'active'
		},
		{
			browser: 'Internet Explorer',
			icon: explorerIcon,
			version: '8.0.6001.18',
			status: 'active'
		},
		{
			browser: 'Brave',
			icon: BraveIcon,
			version: '1.41.100',
			status: 'active'
		},
		{
			browser: 'Tor Browser',
			icon: torIcon,
			version: '12.0.3',
			status: 'active'
		},
		{
			browser: 'Vivaldi',
			icon: vivalryIcon,
			version: '5.4.2753.37',
			status: 'active'
		}
	]

	return (
		<div className='compability-content-container'>
			<h1>{t('page_compability')}</h1>
			<p>
				{t('compatibilit_desc')}
			</p>
			<div>
				<Table
					column={columns}
					data={data}
					showPagination={false}
					onSortedList={() => null}
				/>
			</div>
		</div>
	)
}

export default CompatibilityContent